import { render, staticRenderFns } from "./SelectColumnsSumColsConfig.vue?vue&type=template&id=0acf2b10&scoped=true"
import script from "./SelectColumnsSumColsConfig.vue?vue&type=script&lang=ts"
export * from "./SelectColumnsSumColsConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf2b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acf2b10')) {
      api.createRecord('0acf2b10', component.options)
    } else {
      api.reload('0acf2b10', component.options)
    }
    module.hot.accept("./SelectColumnsSumColsConfig.vue?vue&type=template&id=0acf2b10&scoped=true", function () {
      api.rerender('0acf2b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/SelectColumnsSumColsConfig.vue"
export default component.exports